import ApiService from './ApiService';
export default class StoreRegistrationService extends ApiService {
  constructor(endPointName) {
    super(endPointName);
  }

  registerStore(storeId, data) {
    const _url = this.serviceUrl + this.endpoints.registerStore.replace('{__storeId__}', storeId);
    return this.POST(_url, data);
  }

  confirmAdminIdentity(storeId, data) {
    const _url = this.serviceUrl + this.endpoints.confirmAdminIdentity.replace('{__storeId__}', storeId);
    return this.POST(_url, data);
  }
}
